<template>
    <div class="col-12">
        <div class="row mb-3">
            <div class="h5">
                <span>{{ $lang('Osoba:') }}</span>
                <span class="font-weight-bold">{{ person.name + ' ' + person.surname }}</span>
                <span>{{ '(' + person.library.name + ')' }}</span>
            </div>
        </div>
        <div class="row">
            <table class="table simple-table table-striped table-sm mb-0">
                <thead>
                <tr>
                    <th scope="col">{{ $lang('Projekt') }}</th>
                    <th scope="col">{{ $lang('Dostęp') }}</th>
                    <th scope="col">{{ $lang('Rola w projekcie') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="!projects" class="table-light">
                    <th>
                        {{ $lang('Brak projektów') }}
                    </th>
                </tr>
                <template v-else v-for="project in personProjectRoles">
                    <tr>
                        <td :data-title="$lang('Projekt')" class="align-middle">
                            {{ project.name || "-" }}
                        </td>
                        <td :data-title="$lang('Dostęp')">
                            <select :id="'person_role_access_'+project.id" class="form-control" v-model="project.accessType">
                                <option v-for="accessType in projectAccessTypes" :value="accessType.id">
                                    {{ accessType.name }}
                                </option>
                            </select>
                        </td>
                        <td :data-title="$lang('Rola w projekcie')">
                            <span class="font-italic align-middle pl-1" v-if="project.accessType === 0">
                                {{ $lang('Brak dostępu do projektu') }}
                            </span>
                            <select :id="'person_role_project_'+project.id" v-else-if="project.accessType === 1"
                                    class="form-control" v-model="project.role">
                                <option v-for="projectRole in projectRoles" :value="projectRole.id" v-if="projectRole.id !== 0">
                                    {{ projectRole.name }}
                                </option>
                            </select>
                            <span class="font-italic align-middle pl-1" v-else-if="project.accessType === 2">
                            {{ $lang('Dostęp według modułów') }}
                        </span>
                        </td>
                    </tr>
                    <tr v-if="project.accessType === 2">
                        <td colspan="3" class="inner-table-wrapper">
                            <table class="table simple-table table-striped table-sm my-2">
                                <thead>
                                <tr>
                                    <th scope="col">{{ $lang('Moduł') }}</th>
                                    <th scope="col">{{ $lang('Rola') }}</th>
                                </tr>
                                </thead>
                                <tr>
                                <tr v-if="!projects" class="table-light">
                                    <th>
                                        {{ $lang('Brak modułów w projekcie') }}
                                    </th>
                                </tr>
                                <tr v-else v-for="module in project.modules">
                                    <td :data-title="$lang('Moduł')" class="align-middle">
                                        {{ module.name || "-" }}
                                    </td>
                                    <td :data-title="$lang('Rola')">
                                        <select :id="'person_role_module_'+module.id" class="form-control" v-model="module.role">
                                            <option v-for="projectRole in projectRoles" :value="projectRole.id">
                                                {{ projectRole.name }}
                                            </option>
                                        </select>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <div class="row mt-4 mb-2 float-right">
            <button @click="save" type="button" class="btn btn-primary" data-dismiss="modal">
                {{ $lang('Zapisz') }}
            </button>
        </div>
    </div>
</template>

<script>
import ShowNotification from "../../mixins/show-notification";

export default {
    name: "people-roles-index",
    mixins: [ShowNotification],
    props: {
        save_person_roles_route: String,
        person: Object,
        projects: Array,
        project_roles: Array,
        person_roles: Array|null,
    },
    data() {
        return {
            personProjectRoles: [],
            projectRoleObject: {
                id: null,
                name: null,
                accessType: 0,
                role: 0,
                modules: []
            },
            moduleRoleObject: {
                id: null,
                name: null,
                role: 0,
            },
            projectAccessTypes: [
                {
                    id: 0,
                    name: this.$lang('Brak dostępu')
                },
                {
                    id: 1,
                    name: this.$lang('Dostęp do projektu')
                },
                {
                    id: 2,
                    name: this.$lang('Dostęp wg modułów')
                }
            ],
            projectRoles: this.project_roles,
        }
    },
    created() {
        this.setPersonRoles();
    },
    methods: {
        setPersonRoles() {
           if (this.projects.length > 0) {
               for (let [key, project] of Object.entries(this.projects)) {
                    let projectRole = JSON.parse(JSON.stringify(this.projectRoleObject));
                    let rolesForModules = null;

                    projectRole.id = project.id;
                    projectRole.name = project.jira_key;
                    if (this.person_roles !== null) {
                        let personProjectRolesFromDB = this.person_roles[project.id];
                        if (personProjectRolesFromDB) {
                            let personRoleForProject = personProjectRolesFromDB.find(obj => {
                                return obj.module_id === null;
                            });
                            if (personRoleForProject) {
                                projectRole.accessType = 1;
                                projectRole.role = personRoleForProject.project_role_id;
                            } else {
                                projectRole.accessType = 2;
                                rolesForModules = personProjectRolesFromDB;
                            }
                        }
                    }
                    if (project.modules) {
                        for (let [key, module] of Object.entries(project.modules)) {
                            let moduleRole = JSON.parse(JSON.stringify(this.moduleRoleObject));
                            moduleRole.id = module.module_id;
                            moduleRole.name = module.name;
                            if (rolesForModules) {
                                let personRoleForModule = rolesForModules.find(obj => {
                                    return obj.module_id === module.module_id;
                                });
                                if (personRoleForModule) {
                                    moduleRole.role = personRoleForModule.project_role_id;
                                }
                            }

                            projectRole.modules.push(moduleRole);
                        }
                    }
                    this.personProjectRoles.push(projectRole);
               }
           }
           if (this.projectRoles.length > 0) {
               this.projectRoles.unshift({id: 0, name: this.$lang('Brak dostępu')})
           }
        },
        save() {
            const self = this;
            axios.post(this.save_person_roles_route, {
                person_id: self.person.id,
                person_project_roles: self.personProjectRoles
            })
                .then(response => {
                    if (response.data.save) {
                        self.showNotification('success', 'Pomyślnie edytowano role projektowe osoby!');
                    } else {
                        self.showNotification('error', 'Nie udało się edytować ról projektowych osoby!');
                    }
                })
                .catch(function () {
                    self.showNotification('error', 'Nie udało się edytować ról projektowych osoby!');
                });
        }
    }
}
</script>
<style scoped>
.inner-table-wrapper {
    padding-left: 180px !important;
    padding-right: 0 !important;
}
@media (max-width: 768px) {
    .inner-table-wrapper {
        padding-left: 20px !important;
        padding-right: 0 !important;
    }
}
</style>
